import { Image } from '@mantine/core'
import { IconProps } from '@tabler/icons-react'
import MilestoneLogo from '@/assets/integrations/milestone.png'

type MilestonePipelineIconProps = Pick<IconProps, 'size'>

export const MilestonePipelineIcon = ({
  size = 24
}: MilestonePipelineIconProps) => (
  <Image src={MilestoneLogo} w={size} h={size} fit="contain" />
)
